export default {
    preloadImage: (src) => {
        return new Promise((resolve, reject) => {
            let image = new Image()

            image.onload = () => {
                resolve(image)
            }

            image.onerror = () => {
                reject()
            }

            image.src = src
        })
    },
    isEqual: (obj1, obj2) => {
        return JSON.stringify({ ...obj1 }) === JSON.stringify({ ...obj2 })
    }
};


// WEBPACK FOOTER //
// ./src/common/helper.js